import React from 'react';
import moment from 'moment';
import {
  Row,
  Col,
  Button,
  Table,
  Input,
  Select,
  DatePicker,
  Pagination,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';

const TablaNovedades = ({
  novedades,
  onDelete,
  history,
  total,
  pagina,
  tamPagina,
  cambiarPagina,
  setFiltroUsuario,
  filtroUsuarioPadre,
  setFiltroOrganismo,
  filtroOrganismoPadre,
  setFiltroMedida,
  filtroMedidaPadre,
  setFiltroFecha,
  filtroFechaDesde,
  filtroFechaHasta,
  listaOrganismos,
  listaMedidas,
  loadingTabla,
  setSort,
}) => {
  const [filtroTexto, setFiltroTexto] = React.useState(filtroUsuarioPadre);
  const [filtroOrg, setFiltroOrg] = React.useState(filtroOrganismoPadre);
  const [filtroMed, setFiltroMed] = React.useState(filtroMedidaPadre);

  const columns = [
    {
      title: 'Administrativo',
      dataIndex: 'usuario',
      render: usuario =>
        usuario ? usuario.nombre + ' ' + usuario.apellido : '',
      filterDropdown: (
        <div>
          <Row>
            <Col span={24}>
              <Input
                value={filtroTexto}
                style={{ margin: 10, width: 'calc(100% - 20px)' }}
                placeholder="Buscar por nombre o apellido"
                onChange={e => setFiltroTexto(e.target.value)}
                onPressEnter={() => setFiltroUsuario({ textoUsuario: filtroTexto })}
              />
            </Col>
          </Row>
          <Row>
            <Col offset={10}>
              <Button
                icon={<Icons.FileSearchOutlined />}
                shape="circle"
                type="primary"
                size="small"
                style={{ margin: '8px 8px' }}
                onClick={() => setFiltroUsuario({ textoUsuario: filtroTexto })}
              />
              <Button
                icon={<Icons.CloseOutlined />}
                shape="circle"
                size="small"
                type="danger"
                onClick={() => {
                  setFiltroTexto('');
                  setFiltroUsuario({ textoUsuario: null });
                }}
              />
            </Col>
          </Row>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroTexto ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Organismo',
      dataIndex: 'organismo',
      width: 180,
      render: organismo => organismo ? organismo.nombre : '',
      filterDropdown: (
        <div style={{ padding: 8 }}>
          <Select
            allowClear
            showSearch
            placeholder="Todos"
            style={{ width: 220 }}
            value={filtroOrg || undefined}
            onChange={val => {
              const v = val || null;
              setFiltroOrg(v);
              setFiltroOrganismo(v);
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {(listaOrganismos || []).map(org => (
              <Select.Option key={org._id} value={org._id}>
                {org.nombre}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroOrg ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Tipo de Medida',
      dataIndex: 'tipoMedida',
      width: 150,
      filterDropdown: (
        <div style={{ padding: 8 }}>
          <Select
            allowClear
            placeholder="Todas"
            style={{ width: 180 }}
            value={filtroMed || undefined}
            onChange={val => {
              const v = val || null;
              setFiltroMed(v);
              setFiltroMedida(v);
            }}
          >
            {(listaMedidas || []).map(m => (
              <Select.Option key={m._id} value={m.nombre}>
                {m.nombre}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      filterIcon: () => (
        <Icons.FilterOutlined
          style={{ color: filtroMed ? '#1890ff' : undefined }}
        />
      ),
    },
    {
      title: 'Desde',
      dataIndex: 'fechaDesde',
      width: 160,
      render: fecha => fecha ? moment(fecha).format('DD-MM-YYYY HH:mm') : '',
      sorter: true,
    },
    {
      title: 'Hasta',
      dataIndex: 'fechaHasta',
      width: 160,
      render: fecha => fecha ? moment(fecha).format('DD-MM-YYYY HH:mm') : '',
      sorter: true,
    },
    {
      title: 'Observaciones',
      dataIndex: 'observaciones',
      ellipsis: true,
    },
    {
      title: 'Acciones',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            icon={<Icons.DeleteOutlined />}
            shape="circle"
            size="small"
            type="danger"
            onClick={() => onDelete(record._id)}
            style={{ marginLeft: 5 }}
          />
        </span>
      ),
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={novedades}
        rowKey="_id"
        loading={loadingTabla}
        pagination={false}
        size="small"
        bordered
        onChange={(_, __, sorter) => {
          if (setSort) {
            setSort(sorter.field || null, sorter.order || null);
          }
        }}
      />
      <div style={{ textAlign: 'right', marginTop: 16 }}>
        <Pagination
          current={pagina}
          total={total}
          pageSize={tamPagina}
          onChange={cambiarPagina}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default TablaNovedades;
